import '../vendor/grubersjoe-slide-menu-1.2';
import { pipe, getAdjacentEl } from '../lib/lib';
import { notify } from '../lib/notify';
import { setAriaIsNotHidden, setAriaIsHidden } from '../lib/aria';

const SLIDE_MENU_EVENTS = Object.freeze({
  open: 'slide-menu:open',
  close: 'slide-menu:close',
});

const SLIDE_MENU_ID = 'js-slide-menu'; //'js-c-slide-menu';
const SLIDE_MENU_BACK_ID = 'js-slide-menu__back';
const SLIDE_MENU_SLIDER_CLASS = '.slide-menu__slider';

const SLIDE_MENU_OVERLAY_ID = 'js-slide-menu-overlay';
const slideMenuOpenEvent = notify.that(SLIDE_MENU_EVENTS.open);
const slideMenuCloseEvent = notify.that(SLIDE_MENU_EVENTS.close);

export const slideMenuElement = () => document.getElementById(SLIDE_MENU_ID);
const slideMenuBackElement = () => document.getElementById(SLIDE_MENU_BACK_ID);
const slideMenuSliderElement = () =>
  document.querySelector(SLIDE_MENU_SLIDER_CLASS);
const slideMenuOverlayElement = () =>
  document.getElementById(SLIDE_MENU_OVERLAY_ID);

const showSlideMenuOverlay = pipe(
  slideMenuOverlayElement,
  setAriaIsNotHidden,
  slideMenuOpenEvent(),
);

const hideSlideMenuOverlay = pipe(
  slideMenuOverlayElement,
  setAriaIsHidden,
  slideMenuCloseEvent(),
);

const closeSlideMenu = menu => () => menu.close();

export const initSlideMenu = () => {
  if (slideMenuElement()) {
    const menu = new SlideMenu(slideMenuElement(), {
      showBackLink: false,
      keyClose: 'Escape',
      submenuLinkAfter: '<span class="slide-menu__submenu-icon-back"></span>',
    });

    slideMenuElement().addEventListener('sm.open', showSlideMenuOverlay);
    slideMenuElement().addEventListener('sm.close', hideSlideMenuOverlay);

    const slideMenuActive = 1;
    const isSubmenuActive = () =>
      slideMenuElement().querySelectorAll('.slide-menu__submenu--active')
        .length > slideMenuActive
        ? true
        : false;

    slideMenuElement().addEventListener('sm.forward', function(event) {
      setAriaIsNotHidden(slideMenuBackElement());
    });

    slideMenuElement().addEventListener('sm.back-after', function(event) {
      !isSubmenuActive() ? setAriaIsHidden(slideMenuBackElement()) : null;
    });

    var current = document.querySelector('.js-slide-menu-current');

    menu.navigateTo(current);
    isSubmenuActive() ? setAriaIsNotHidden(slideMenuBackElement()) : null;
    slideMenuOverlayElement().addEventListener('click', closeSlideMenu(menu));
  }
};
